import SmartLabel, { smartLabelColors } from "@/domain/enums/SmartLabel";
import { darken, lighten } from "polished";
import { useTranslation } from "react-i18next";

type SmartLabelWithNameProps = {
    smartLabel: SmartLabel;
};

const SmartLabelWithName = ({ smartLabel }: SmartLabelWithNameProps) => {
    const { t } = useTranslation();

    return (
        <div
            className="flex items-center gap-1 rounded-full px-2 py-1"
            style={{
                border: `1px solid ${smartLabelColors[smartLabel]}`,
                backgroundColor: lighten(0.45, smartLabelColors[smartLabel]),
            }}
        >
            <div
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: smartLabelColors[smartLabel] }}
            />
            <p style={{ color: darken(0.2, smartLabelColors[smartLabel]) }}>
                {t(`navbar.smartLabels.navigation.${smartLabel}`)}
            </p>
        </div>
    );
};

export default SmartLabelWithName;
